import React from 'react';

import Base from './Base';
import { stripeCheckoutFormText } from '../../../utils/constants';

const CCUpdateHeader = props => {
    const { isPaymentByDefaultCard, isUsingStripeForm } = props;

    // setting conditional modal subtitle
    const modalSubTitle = () => {
        let subText = '';
        if (isUsingStripeForm) {
            subText = stripeCheckoutFormText.sub_text_form;
        } else if (isPaymentByDefaultCard) {
            subText = stripeCheckoutFormText.default_card_page_title;
        } else {
            subText = stripeCheckoutFormText.sub_text_payment_methods;
        }
        return subText;
    };

    return (
        <Base title={stripeCheckoutFormText.cc_update_title} subText={modalSubTitle()} {...props} />
    );
};

export default CCUpdateHeader;
